import { Box, Typography } from "@mui/material";

const appVersion = process.env.REACT_APP_VERSION ?? "version_error";
const versionInfo = `${appVersion}`;

/** ロゴの代わり */
const PlaceholderLogo = () => {
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      sx={{
        borderRadius: 1,
        mx: "auto",
        my: 2,
        gap: 2,
      }}
    >
      <Typography variant="h4" color="text.secondary">
        RobotManagement
      </Typography>
      <Typography variant={"caption"} color="text.secondary">
        {versionInfo}
      </Typography>
    </Box>
  );
};

export default PlaceholderLogo;
